import { render, staticRenderFns } from "./EmailSetup.vue?vue&type=template&id=f869fa52&scoped=true"
import script from "./EmailSetup.vue?vue&type=script&lang=js"
export * from "./EmailSetup.vue?vue&type=script&lang=js"
import style0 from "./EmailSetup.vue?vue&type=style&index=0&id=f869fa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f869fa52",
  null
  
)

export default component.exports